import { get } from './v2';

export const getCommercialCommunication = () => get(`/v3/communication/commercial-information/display`);
export const getMaintenanceCommunication = () => get(`/v3/communication/maintenance/active`);
